import { MirroringData } from 'store/declarations/declaration';

/**
 * The text next to the link icon in the declarations table:
 * - one mirror: its type ("H1")
 * - several of one type: "2 B1s"
 * - several of mixed types: "3 declarations", since naming only one of them would be wrong
 */
export const getMirroredLinksLabel = (data: MirroringData | undefined) => {
    const count = data?.createdDeclarationsCount ?? 0;
    if (!data || count === 0) return undefined;

    const types = data.createdDeclarationsByType;
    const hasSingleType = types.length === 1;
    const typeName = hasSingleType ? types[0].declarationName : undefined;

    if (count === 1) return typeName ?? '1 declaration';
    if (typeName) return `${count} ${typeName}s`;

    return `${count} declarations`;
};
